module.exports = __webpack_public_path__ + "img/logo-toolbar.91b5db0f.svg";